var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirmware(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "firmware",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41899",
    "data-name": "Path 41899",
    d: "M4.28,4.274H19.73V19.722H4.28ZM7.091,0V2.847H2.866V7.07H0V8.477H2.845v2.814H0V12.7H2.845v2.814H0v1.407H2.858v4.215H7.082V24H8.489V21.155H11.3V24h1.407V21.155h2.814V24h1.407V21.142h4.216V16.927H24v-1.41H21.17V12.708h2.825V11.3H21.166V8.488H24V7.078H21.164V2.854H16.94V.007h-1.41v2.83H12.72V0H11.31V2.832H8.493V0Z",
    fill: "#667380"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41900",
    "data-name": "Path 41900",
    d: "M118.877,114.438h1.4v-1.382h1.4v1.387h1.406v1.4H121.71v1.411h1.374v1.411h-1.378v1.4h1.382v1.4H121.7v1.406h-1.4V121.5h-1.411v1.374h-1.411V121.5h-1.4v1.382h-1.4V121.49h-1.406v-1.4h1.379v-1.411H113.27v-1.411h1.378v-1.4h-1.382v-1.4h1.387v-1.406h1.4v1.379h1.411V113.06h1.411Zm-2.794,5.62h4.192v-4.192h-4.192Z",
    transform: "translate(-106.17 -105.972)",
    fill: "#667380"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20876",
    "data-name": "Rectangle 20876",
    width: 1.372,
    height: 1.385,
    transform: "translate(5.691 5.668)",
    fill: "#667380"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20877",
    "data-name": "Rectangle 20877",
    width: 1.376,
    height: 1.38,
    transform: "translate(16.949 5.678)",
    fill: "#667380"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20878",
    "data-name": "Rectangle 20878",
    width: 1.369,
    height: 1.386,
    transform: "translate(5.695 16.924)",
    fill: "#667380"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20879",
    "data-name": "Rectangle 20879",
    width: 1.38,
    height: 1.378,
    transform: "translate(16.943 16.936)",
    fill: "#667380"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20880",
    "data-name": "Rectangle 20880",
    width: 1.378,
    height: 1.378,
    transform: "translate(11.316 11.309)",
    fill: "#667380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmware);
export default __webpack_public_path__ + "static/media/firmware.5f008e04f06de14eeacf72f8e3d6177f.svg";
export { ForwardRef as ReactComponent };